import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { api, i18n } from "@/lib/api";

function detectLanguage() {
  const param = new URLSearchParams(window.location.search).get("lang");
  if (param === "es" || param === "en") return param;
  const stored = typeof localStorage !== "undefined" ? localStorage.getItem("pta_lang") : null;
  return stored === "es" ? "es" : "en";
}

export default function PublicTemplate({ slug }) {
  const [language] = useState(detectLanguage());
  const t = i18n[language] || i18n.en;
  const [state, setState] = useState({ loading: true, template: null, error: null });

  useEffect(() => {
    let active = true;
    api
      .getPublicTemplate(slug)
      .then((r) => {
        if (active) setState({ loading: false, template: r.template, error: null });
      })
      .catch((e) => {
        if (active) {
          const notFound = e?.response?.status === 404;
          setState({ loading: false, template: null, error: notFound ? "notfound" : "error" });
        }
      });
    return () => {
      active = false;
    };
  }, [slug]);

  const { loading, template, error } = state;
  const homeUrl = `${window.location.origin}/`;
  const title = template ? template.custom_document_name || template.document_title : "";

  return (
    <div
      data-testid="public-template-page"
      style={{ minHeight: "100vh", maxWidth: 820, margin: "0 auto", padding: "3rem 1.5rem 5rem" }}
    >
      <div className="h-eyebrow" data-testid="public-brand">
        POCKET TA AI
      </div>

      {loading && (
        <p className="txt-mute" data-testid="public-template-loading" style={{ marginTop: "2rem" }}>
          {t.loading}
        </p>
      )}

      {!loading && error === "notfound" && (
        <p className="txt-mute" data-testid="public-template-notfound" style={{ marginTop: "2rem" }}>
          {t.templateNotFound}
        </p>
      )}

      {!loading && error === "error" && (
        <p className="txt-danger" data-testid="public-template-error" style={{ marginTop: "2rem" }}>
          {t.templateError}
        </p>
      )}

      {!loading && template && (
        <div data-testid="public-template-content">
          <div className="kbd" style={{ marginTop: "2rem" }}>
            {t.sharedTemplateLabel}
          </div>
          <h1 className="h-display" data-testid="public-template-title" style={{ marginTop: "0.5rem" }}>
            {title}
          </h1>
          <div className="kbd" style={{ marginTop: "0.5rem" }}>
            {template.document_type}
            {template.created_at ? ` - ${new Date(template.created_at).toLocaleDateString()}` : ""}
          </div>
          <div className="line" style={{ margin: "1.5rem 0" }} />
          <article className="markdown-body">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{template.processed_analysis || ""}</ReactMarkdown>
          </article>
        </div>
      )}

      <div className="line-strong" style={{ margin: "2.5rem 0 1rem" }} />
      <p className="txt-mute" style={{ fontSize: "0.85rem" }}>
        {t.publicTemplateBy}{" "}
        <a
          data-testid="public-template-home-link"
          href={homeUrl}
          style={{ color: "var(--ink)", borderBottom: "1px solid var(--ink-faint)" }}
        >
          {t.backToHome}
        </a>
      </p>
    </div>
  );
}
